import { Injector, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { META, META_DEFAULT, TITLE, TITLE_DEFAULT } from '../core/constants/meta_title.constant';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MESSAGES } from '../core/constants/messages.constant';

export class BaseComponents implements OnInit {
    constructor(protected injector: Injector) {
        this.titleService = injector.get(Title);
        this.meta = injector.get(Meta);
        this.router = injector.get(Router);
        this.toast = injector.get(ToastrService);
    }
    public metaElement = META;
    public title = TITLE;
    public metaDefault = META_DEFAULT;
    public titleDefault = TITLE_DEFAULT;
    public showChat: boolean;
    public innerWidth: any;
    public isIphone = false;
    showToggleNavbar = false;
    isMobile = false;
    propostaUrls = [
        '/faca-parte',
        '/login',
        '/exclusividade',
        '/pagamentos',
        '/pagamento-credito',
        '/pagamento-debito',
        '/seguranca',
        '/confirmacao',
        '/confirmacao-compra',
        '/proposta-analise',
        '/pagamento-boleto',
        '/dados-pessoais',
        '/faca-parte-obrigado'
    ];
    salesUrls = [
        '/confirmacao-sales',
    ];

    newView = [
        '/nova-home'
    ];

    public srcYoutube = 'https://www.youtube.com/embed/-LhZBumSFkk';
    public srcRegulamento = 'https://bit.ly/reg_montreal';
    protected titleService: Title;
    protected meta: Meta;
    protected router: Router;
    protected toast: ToastrService;

    remBreakpoints = {
        xs: 1,
        sm: 37.5,
        md: 45,
        lg: 52.5,
        xl: 79.5,
    };

    gridTheme = {
        breakpoints: {
            xs: this.remToPx(this.remBreakpoints.xs),
            sm: this.remToPx(this.remBreakpoints.sm),
            md: this.remToPx(this.remBreakpoints.md),
            lg: this.remToPx(this.remBreakpoints.lg),
            xl: this.remToPx(this.remBreakpoints.xl),
        }
    };

    ngOnInit(): void {
        this.handleMobile();
    }

    setMetaTitle(type: string) {
        this.setTitle(type);
        this.setMeta(type, name);
    }

    setTitle(type: string) {
        const title = this.title.filter(element => element.type === type);
        const result = (title) ? title[0].value : this.titleDefault;
        this.titleService.setTitle(result);
    }

    setMeta( type: string = 'HOME', name: string = 'description', content: string = '') {
        if (content === '') {
            const meta = this.metaElement.filter(element => element.type === type);
            const result = (meta) ? {name, content: meta[0].content} : this.metaDefault;
            this.meta.addTag(result);
            return;
        }
        this.meta.addTag({name, content });
    }


    remToPx(remp: number) {
        return remp * 16;
    }

     handleMobile() {
        if (typeof window !== 'undefined') {
            this.innerWidth = window.innerWidth;
            if (this.innerWidth < this.gridTheme.breakpoints.lg) {
                this.isMobile = true;
                this.showToggleNavbar = true;
                return;
            }
        }
        this.isMobile = false;
        this.showToggleNavbar = false;
    }

    scroll(el) {
        const yOffset = -150;
        const element = document.getElementById(el);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }

    setToUpperCase(value: string) {
        if (value === null) {
            return '';
        }
        value = value.trim().toUpperCase();
        return  value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    fieldCssClass(form: FormGroup, campo: string) {
        if (form.controls[campo].pristine) {
            return '';
        }
        return form.controls[campo].errors ? 'campo-error' : 'campo-success';
    }
    lostTokenSales(notAvailable = false, message = '', title = '') {
        // const hasTokenSales = localStorage.getItem('currentSalesApi') !== null;
        // if (!hasTokenSales && !notAvailable) {
        //     return {notAvailable: !hasTokenSales, message: MESSAGES.ERROR_SALES_TOKEN, title};
        // }
        return {notAvailable, message, title};
    }
    transformDayOrMonth(value) {
        const result = (value).toString();
        return result.length > 1 ? result : `0${result}`;
    }

    getTime(endOfMaintenance) {
        const minute = endOfMaintenance.getMinutes() === 0 ? '' : endOfMaintenance.getMinutes();
        return `${endOfMaintenance.getHours()}h${minute}`;
    }
    messageMaintenance(endOfMaintenance) {
        const month = this.transformDayOrMonth((endOfMaintenance.getMonth() + 1));
        const day = this.transformDayOrMonth(endOfMaintenance.getDate());
        const date = `${day}/${month}/${endOfMaintenance.getFullYear()}`;
        const time = this.getTime(endOfMaintenance);
        let message = MESSAGES.MAINTENANCE;
        message = message.replace('$date', date);
        message = message.replace('$time', time);
        return message;
    }
    isMaintenance() {
        const title = '';
        const startOfMaintenance = new Date(3000, 0, 0, 0, 0, 0);
        const endOfMaintenance = new Date(3000, 0, 0, 0, 0, 0);
        const message = this.messageMaintenance(endOfMaintenance);
        const currentDate = new Date();
        const notAvailable = currentDate > startOfMaintenance  && currentDate <= endOfMaintenance;
        return this.lostTokenSales(notAvailable, message, title);
    }
    async goToCart() {
        const {notAvailable = false, message = '', title = ''} = this.isMaintenance();
        if (notAvailable) {
            this.toast.error(message, title, { timeOut: 5000});
            return;
        }
        await this.router.navigate(['faca-parte']);
    }

    async goToClient() {
        await this.router.navigate(['community']);
    }

    openChat() {
        this.showChat = true;
    }
    closeChat(event?: any) {
        if (event) {
            this.showChat = false;
        }
    }
}
